/**
 * @file: 移动选择器选中态
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import { moveShelfSelect } from './shelf';
import { moveFreezerSelect } from './freezer';
import { movePartitionSelect } from './partition';
import { moveGoodsSelect } from './goods';
import { moveTextareaSelect } from './textarea';
import { moveBafflePlateSelect } from './bafflePlate';

function moveSelected(beAddedCube: CubeNode, task: InsertInfo): void {
    if (CubeTree.isShelf(beAddedCube.id)) {
        moveShelfSelect(beAddedCube, task);
    }
    else if (CubeTree.isFreezer(beAddedCube.id)) {
        moveFreezerSelect(beAddedCube, task);
    }
    else if (CubeTree.isPartition(beAddedCube.id)) {
        movePartitionSelect(beAddedCube, task);
    }
    else if (CubeTree.isGoods(beAddedCube.id)) {
        moveGoodsSelect(beAddedCube, task);
    }
    else if (CubeTree.isTextarea(beAddedCube.id)) {
        moveTextareaSelect(beAddedCube, task);
    }
    else if (CubeTree.isBafflePlate(beAddedCube.id)) {
        moveBafflePlateSelect(beAddedCube, task);
    }
}

export {
    moveSelected
};
